export const draggable = {
  mounted(el, binding) {
    // 设置基本样式
    el.style.position = 'fixed'

    // 状态变量
    let isDragging = false
    let initialX
    let initialY
    let currentX
    let currentY

    // 鼠标按下事件处理
    function handleMouseDown(e) {
      // 只响应鼠标左键
      if (e.button !== 0) return

      isDragging = true
      initialX = e.clientX - el.offsetLeft
      initialY = e.clientY - el.offsetTop

      el.dataset.isMoved = 'false'

      // 阻止默认行为和冒泡
      e.preventDefault()
      e.stopPropagation()

      // 添加事件监听
      document.addEventListener('mousemove', handleMouseMove)
      document.addEventListener('mouseup', handleMouseUp)
    }

    // 鼠标移动事件处理
    function handleMouseMove(e) {
      if (!isDragging) return

      if (binding.value?.onDragMove) {
        binding.value.onDragMove(e, el)
      }

      currentX = e.clientX - initialX
      currentY = e.clientY - initialY

      el.dataset.isMoved = 'true'
      el.style.cursor = 'move'

      // 计算边界
      const maxX = window.innerWidth - el.offsetWidth
      const maxY = window.innerHeight - el.offsetHeight

      // 限制在父元素范围内
      currentX = Math.min(Math.max(0, currentX), maxX)
      currentY = Math.min(Math.max(0, currentY), maxY)

      // 更新位置
      el.style.left = currentX + 'px'
      el.style.top = currentY + 'px'

      // 阻止默认行为和冒泡
      e.preventDefault()
      e.stopPropagation()
      el.dataset.isMoved = 'true'
    }

    // 鼠标松开事件处理
    function handleMouseUp(e) {
      isDragging = false
      el.style.cursor = 'pointer'

      // 移除事件监听
      document.removeEventListener('mousemove', handleMouseMove)
      document.removeEventListener('mouseup', handleMouseUp)

      // 阻止默认行为和冒泡
      e.preventDefault()
      e.stopPropagation()
    }

    // 添加鼠标按下事件监听
    el.addEventListener('mousedown', handleMouseDown)

    // 保存清理函数
    el._dragCleanup = () => {
      el.removeEventListener('mousedown', handleMouseDown)
      document.removeEventListener('mousemove', handleMouseMove)
      document.removeEventListener('mouseup', handleMouseUp)
      el.dataset.isMoved = 'false'
    }
  },

  // 组件卸载时清理事件监听
  unmounted(el) {
    if (el._dragCleanup) {
      el._dragCleanup()
      delete el._dragCleanup
    }
  }
}

export default draggable
